import { useUpdateEffect } from "react-use";

export const useScrollToError = (variable: any) => {
  useUpdateEffect(() => {
    document.querySelector(`.Mui-error`)?.scrollIntoView({ block: "center", behavior: "smooth" });
  }, [variable]);
};
